import { Role } from "@/router/_helper";

const oauth2 = {
  // Define the base path with optional parameters: status, vendor, and msg.
  path: "/oauth2/:status?/:vendor?/:msg?",
  name: "oauthVendorList",
  component: () =>
    import(
      /* webpackChunkName: "oauth-list" */ "@/components/oauth2/OAuthVendorList.vue"
    ),
  meta: { authorize: [Role.ManageSettings], requiresAuth: true },
  // Pass route parameters as props to the component
  props: route => ({
    status: route.params.status,
    vendor: route.params.vendor,
    msg: route.params.msg // This will hold the error message if status is "failed"
  }),
};

export default oauth2;
